/**
 * Sidebar navigation items.
 *
 * Array order IS display order.
 * `role` restricts the item to users whose displayName includes that string
 * (e.g. "reception" or "work"). When a role-restricted user is detected,
 * ONLY their matching items are shown.
 * `children` are rendered in the secondary sidebar panel when the parent is active.
 */
export const navigationItems = [
  { title: 'Stream', path: 'stream', icon: 'lightning-bolt' },
  { title: 'Dashboard', path: 'dashboard', icon: 'view-dashboard' },
  { title: 'Calendar', path: 'bookings2', icon: 'calendar-clock', role: 'reception' },
  { title: 'Items', path: 'items', icon: 'shape' },
  { title: 'Categories', path: 'categories', icon: 'sitemap' },
  { title: 'Customers', path: 'customers', icon: 'account-multiple' },
  { title: 'Staff', path: 'staff', icon: 'account-hard-hat' },
  {
    title: 'Sales',
    path: 'sales',
    icon: 'cart',
    children: [
      { title: 'Invoices', path: 'sales/invoices' },
      { title: 'Orders', path: 'sales/orders' },
      { title: 'Estimates', path: 'sales/estimates' },
    ]
  },
  { title: 'Payments', path: 'payments', icon: 'credit-card-outline' },
  { title: 'Reports', path: 'reports', icon: 'file-document-multiple' },
  { title: 'Forms of Payment', path: 'forms-of-payment', icon: 'wallet-giftcard' },
  { title: 'Point Cards', path: 'point-cards', icon: 'wallet-membership' },
  { title: 'Subscriptions', path: 'subscriptions', icon: 'sync' },
  {
    title: 'Store',
    path: 'store',
    icon: 'store',
    children: [
      { title: 'Locations', path: 'store/locations' },
      { title: 'Discounts', path: 'store/discounts' },
      { title: 'Items', path: 'store/items' },
      { title: 'Bulk Edit', path: 'store/bulk-edit' },
      { title: 'Categories', path: 'store/categories' },
      { title: 'Coupons', path: 'store/coupons' },
      { title: 'Taxes', path: 'store/taxes' },
      { title: 'Delivery Services', path: 'store/delivery-services' },
      { title: 'Sorting', path: 'store/sorting' },
      { title: 'Offers', path: 'store/offers' },
    ]
  },
  { title: 'Coupons', path: 'coupons', icon: 'ticket-percent' },
  { title: 'Work', path: 'work', icon: 'clipboard-flow-outline', role: 'work' },
  { title: 'Translations', path: 'translations', icon: 'translate' },
  { title: 'Process Display Systems', path: 'process-display-systems', icon: 'remote-desktop' },
  { title: 'Order Status Display Systems', path: 'order-status-displays', icon: 'television-guide' },
  { title: 'Sites', path: 'sites', icon: 'earth' },
  { title: 'Bookings Old', path: 'bookings', icon: 'ticket' },
  { title: 'Store Widgets', path: 'store-widgets', icon: 'storefront' },
  { title: 'Schedule Widgets', path: 'schedule-widgets', icon: 'book' },
  { title: 'Kiosks', path: 'kiosks', icon: 'cellphone-dock' },
  { title: 'Integrations', path: 'integrations', icon: 'apps-box' },
  { title: 'Printers', path: 'printers', icon: 'printer-pos' },
  { title: 'Templates', path: 'templates', icon: 'view-quilt' },
  { title: 'Upsell Groups', path: 'upsell-groups', icon: 'briefcase-arrow-up-down-outline' },
]
